import { useState } from 'react';
import { Marker, Popup } from 'react-map-gl/mapbox';
import type { PickupPoint } from '../../../../types/gcs/pickupPoint';
import { getMapElementZIndex, MapElement } from '../../../../types/ui/mapElement';
import { Text } from '../../../../components/general/Text';

interface PickupPointMarkerProps {
  pickupPoint: PickupPoint;
}

export const PickupPointMarker = ({ pickupPoint }: PickupPointMarkerProps) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <>
      <Marker
        longitude={pickupPoint.location.lng}
        latitude={pickupPoint.location.lat}
        anchor='center'
        style={{ zIndex: getMapElementZIndex(MapElement.PICKUP_POINT) }}
      >
        <svg
          width='32'
          height='32'
          viewBox='0 0 40 40'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          style={{ cursor: 'pointer' }}
          onClick={(event) => {
            event.stopPropagation();
            setIsPopupOpen((prev) => !prev);
          }}
        >
          <circle cx='20' cy='20' r='19' fill='var(--map-element-on-ground)' stroke='white' strokeWidth='2' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M24.7857 14.848C24.7857 12.1705 22.5491 10 19.7901 10C17.0311 10 14.7944 12.1705 14.7944 14.848V17.1924C14.7944 17.933 15.7027 17.933 16.611 17.933C17.4919 17.933 18.945 17.8751 19.3359 18.3737C20.582 19.9631 22.3363 24.1008 21.5979 25.4253C20.8595 26.7497 19.5409 26.8927 18.6479 26.5564C17.3103 26.0528 16.587 24.6424 16.0558 22.9595C15.7257 21.9134 15.5317 21.0181 15.2486 21.0181C14.6839 21.0181 14.7945 26.3067 14.7945 26.3067C14.7945 29.3918 17.7883 30 19.7785 30C22.0521 30 24.7857 29.0949 24.7857 24.658V14.848Z'
            fill='white'
          />
        </svg>
      </Marker>
      {isPopupOpen && (
        <Popup
          longitude={pickupPoint.location.lng}
          latitude={pickupPoint.location.lat}
          anchor='bottom'
          offset={32}
          className='marker-popup'
          closeButton={true}
          closeOnClick={true}
          onClose={() => setIsPopupOpen(false)}
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <Text variant='body2'>{pickupPoint.name}</Text>
          </div>
        </Popup>
      )}
    </>
  );
};
